import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Company } from "../../domain/model/company";
import { Occupation, Project } from "../../domain/model/project";
import { createClientProjectDetailActionCreator } from "../action/client_project_action";
import ClientProjectComponent from "../component/client/project/client_project";
import {
  IClientProjectDetailDispatcher,
  createClientProjectDetailDispatcher,
} from "../dispatcher/client_project_dispatcher";
import {
  CreateProjectDetailByClientRequest,
  GetProjectDetailByClientRequest,
  UpdateProjectDetailByClientRequest,
} from "../request/project_request";
import { AppState } from "../store/app_state";
import { ClientProjectDetailState } from "../store/client_project_state";

interface IProps {
  state: ClientProjectDetailState;
  dispatcher: IClientProjectDetailDispatcher;
  history: any;
  location: any;
  match: any;
}

interface IState {
  isInit: boolean;
}

export class ClientProject extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const mode: string = this.props.match.params.mode;
    const reqGetProject: GetProjectDetailByClientRequest =
      new GetProjectDetailByClientRequest();

    if (mode !== "create") {
      reqGetProject.projectId = this.props.match.params.projectId;
      this.props.dispatcher.getProject(reqGetProject);
    }
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { state, match } = this.props;
    const { isInit } = this.state;

    const mode: string = match.params.mode;

    const project: Project | null = state.project;
    const company: Company | null = state.company;

    const isLoading: boolean = state.isLoading;

    return (
      <ClientProjectComponent
        isInit={isInit}
        isLoading={isLoading}
        mode={mode}
        project={project}
        company={company}
        handleUpdateProjectSubmit={this.handleUpdateProjectSubmit}
        handleCreateProjectSubmit={this.handleCreateProjectSubmit}
      />
    );
  }

  private handleUpdateProjectSubmit = (values: any): void => {
    const req: UpdateProjectDetailByClientRequest =
      new UpdateProjectDetailByClientRequest();
    req.id = values.project.id;
    req.name = values.project.name;
    req.description = values.project.description;
    req.background = values.project.background;
    req.preferentialExperience = values.project.preferentialExperience;
    req.thumbnailURL = values.project.gsThumbnailURL;
    req.place = Number(values.project.place);
    req.workingHourRange = Number(values.project.workingHourRange);
    req.paymentRange = Number(values.project.paymentRange);
    req.workingDuration = Number(values.project.workingDuration);
    req.occupations = values.project.occupations
      ? values.project.occupations.map((item: Occupation) => {
          return Number(item);
        })
      : [];
    req.status = Number(values.project.status);
    req.operatingDate = values.project.operatingDate;
    req.isHideCompany = values.project.isHideCompany;
    req.uploadFileThumbnailURL = values.thumbnailURLFileObject;
    this.props.dispatcher.updateProject(req);
  };

  private handleCreateProjectSubmit = (values: any): void => {
    const req: CreateProjectDetailByClientRequest =
      new CreateProjectDetailByClientRequest();
    req.name = values.name;
    req.description = values.description;
    req.background = values.background;
    req.preferentialExperience = values.preferentialExperience;
    req.thumbnailURL = values.thumbnailURL;
    req.place = values.place;
    req.workingHourRange = values.workingHourRange;
    req.paymentRange = values.paymentRange;
    req.workingDuration = values.workingDuration;
    req.occupations = values.occupations
      ? values.occupations.map((item: Occupation) => {
          return Number(item);
        })
      : [];
    req.operatingDate = values.operatingDate;
    req.isHideCompany = values.isHideCompany;
    req.uploadFileThumbnailURL = values.thumbnailURLFileObject;
    req.status = Number(values.status);
    this.props.dispatcher.createProject(req);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientProjectDetailReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientProjectDetailDispatcher(
      dispatch,
      createClientProjectDetailActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientProject);



// WEBPACK FOOTER //
// ./src/presentation/container/client_project_container.tsx